import styled from 'styled-components';
import { getAlertColors } from '../utils/alertInfoHelpers';

export const AlertContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'};
  border-radius: ${props => (props.theme.radii && props.theme.radii.md) || '8px'};
  border-left: 4px solid;
  margin-bottom: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'};

  ${props => {
    const colors = getAlertColors(props.type, props.theme);
    return `
      background-color: ${colors.bg};
      border-left-color: ${colors.border};
      color: ${colors.text};
    `;
  }}
`;

export const AlertIconWrapper = styled.div`
  margin-right: ${props => (props.theme.spacing && props.theme.spacing.sm) || '12px'};
  margin-top: 2px;
  
  ${props => {
    const colors = getAlertColors(props.type, props.theme);
    return `color: ${colors.border};`;
  }}
`;

export const AlertContent = styled.div`
  flex: 1;
`;

export const AlertTitle = styled.h4`
  margin: 0 0 4px 0;
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.md) || '16px'};
  font-weight: 600;
`;

export const AlertMessage = styled.p`
  margin: 0;
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px'};
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/AlertInfo/components/AlertInfoStyles.js